import { useStoreInfo } from "../../context/StoreInfoContext";
import { useAuth } from "../../context/AuthContext";
import { Navigate, useLocation } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { useTheme } from "../../theme/ThemeContext";

const ProtectedRoute = ({ children }) => {
  const { storeInfo, loading: storeLoading } = useStoreInfo();
  const { user, loading: authLoading } = useAuth();
  const location = useLocation();
  const theme = useTheme();
  // Show loading spinner while either store info or auth is loading
  if (storeLoading || authLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          backgroundColor: theme?.store_background_color,
        }}
      >
        <CircularProgress size={60} />
      </Box>
    );
  }

  // If store is public (is_public === 1), allow access to all
  if (storeInfo?.store?.is_public === 1) return children;

  if (!user) {
    return (
      <Navigate
        to={`/login${location.search || ""}`}
        state={{ from: location }}
        replace
      />
    );
  }

  return children;
};
export default ProtectedRoute;
